<div
  class="fgbcl-game-predictor-mutlti-conter-section"
  [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }"
>
  <ng-container *ngIf="answers[0].ImageUrl">
    <img
      class="fgbcl-game-predictor-counter-answer-image"
      [src]="answers[0].ImageUrl | contentImage: '7'"
      alt="{{ answers[0].Title }}"
    />
  </ng-container>
  <fgbcl-counter (countEmitter)="onAnswerSelected(answers[0].Id, $event)" [count]="answers[0].Value"></fgbcl-counter>
  <fgbcl-counter (countEmitter)="onAnswerSelected(answers[1].Id, $event)" [count]="answers[1].Value"></fgbcl-counter>
  <ng-container *ngIf="answers[1].ImageUrl">
    <img
      class="fgbcl-game-predictor-counter-answer-image"
      [src]="answers[1].ImageUrl | contentImage: '7'"
      alt="{{ answers[0].Title }}"
    />
  </ng-container>
</div>
